/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import { BsArrowRight } from 'react-icons/bs';
import * as React from 'react';

import { IPromoBannerViewProps } from '@msdyn365-commerce-modules/promo-banner/src/modules/promo-banner/./promo-banner';
import { IPromoBannerProps } from '../definition-extensions/promo-banner.ext.props.autogenerated';

const PromoBannerView: React.FC<IPromoBannerViewProps & IPromoBannerProps<{}>> = props => {
    const {
        promoBannerProps,
        contentProps,
        closeButton,
        bannerMessages,
        promoBannerTextProps,
        promoBannerLinksProps,
        carouselProps,
        promoBannerText,
        handleLinks,
        handleText
    } = props;

    const userInfo = props.context && props.context.request && props.context.request.user;

    const slides =
        bannerMessages &&
        bannerMessages.map((message, index) => {
            return (
                <Node {...contentProps} key={index} aria-live='polite' role='marquee'>
                    <span className='sr-only'>{promoBannerText}</span>
                    {message.text && <Node {...promoBannerTextProps} text={message.text} onClick={handleText} />}
                    <a className='ms-promo-banner__gotobtn' title='Go to' href={userInfo.signInUrl}>
                        <BsArrowRight />
                    </a>
                    {message.links && message.links.length > 0 && (
                        <Node {...promoBannerLinksProps} links={message.links} onClick={handleLinks} />
                    )}
                </Node>
            );
        });

    return (
        <Module {...promoBannerProps}>
            <Node {...carouselProps} items={slides} />
            {closeButton}
        </Module>
    );
};
export default PromoBannerView;
